import React from 'react'
import './Quickform.css'

const Quickform = () => {
  return (
    <div className='quickformcontainer'>
         <div className='container'>
                <h2 className='textblack p2 text-center'>QUICK ACCESS FORM</h2>
                <div className='accessforms'>
                    <div>
                         <div className='btncont'>
                             <button className="buttoncontainer"><a href='https://eaekanemconsulting.fillout.com/t/cHFwV4e4gHus'>Click Here</a></button>
                        </div>
                        <p className='text-center'>Agent Sign Up Form</p>
                    </div>
                   <div>
                         <div className='btncont'>
                             <button className="buttoncontainer"><a href='https://eaekanemconsulting.fillout.com/t/wqUiqTLuF4us'>Click Here</a></button>
                        </div>
                        <p className='text-center'>Tenant Aquaintance Form</p>
                    </div>
                    <div>
                        <div className='btncont'>
                             <button className="buttoncontainer"><a href='https://eaekanemconsulting.fillout.com/t/eyqDXVu5ULus'>Click Here</a></button>
                        </div>
                        
                        <p className='text-center'>Enquiry Form</p>
                    </div>
                  
                </div>
        </div>
    </div>
  )
}

export default Quickform